import React from 'react'
import { colors } from '../../styles/theme'

const MapPinIcon = () => {
  const bgColor = colors.brandMidnightBlue
  const color = colors.neutralsWhite
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill={bgColor} />
      <rect
        width="24"
        height="24"
        transform="translate(12 12)"
        fill={bgColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 13.875C21.8451 13.875 19.7785 14.731 18.2548 16.2548C16.731 17.7785 15.875 19.8451 15.875 22C15.875 25.1483 17.92 28.185 20.1352 30.5232C21.2249 31.6735 22.3176 32.6147 23.1388 33.2686C23.481 33.5411 23.7748 33.7627 24 33.9278C24.2252 33.7627 24.519 33.5411 24.8612 33.2686C25.6824 32.6147 26.7751 31.6735 27.8648 30.5232C30.08 28.185 32.125 25.1483 32.125 22C32.125 19.8451 31.269 17.7785 29.7452 16.2548C28.2215 14.731 26.1549 13.875 24 13.875ZM24 35C23.5146 35.728 23.5144 35.7279 23.5142 35.7277L23.5115 35.7259L23.505 35.7216L23.4826 35.7064C23.4634 35.6934 23.4359 35.6746 23.4007 35.6502C23.3303 35.6015 23.2289 35.5303 23.101 35.4379C22.8451 35.2531 22.4825 34.9831 22.0487 34.6376C21.1824 33.9478 20.0251 32.9515 18.8648 31.7268C16.58 29.315 14.125 25.8517 14.125 22C14.125 19.381 15.1654 16.8692 17.0173 15.0173C18.8692 13.1654 21.381 12.125 24 12.125C26.619 12.125 29.1308 13.1654 30.9827 15.0173C32.8346 16.8692 33.875 19.381 33.875 22C33.875 25.8517 31.42 29.315 29.1352 31.7268C27.9749 32.9515 26.8176 33.9478 25.9513 34.6376C25.5175 34.9831 25.1549 35.2531 24.899 35.4379C24.7711 35.5303 24.6697 35.6015 24.5993 35.6502C24.5641 35.6746 24.5366 35.6934 24.5174 35.7064L24.495 35.7216L24.4885 35.7259L24.4865 35.7273C24.4863 35.7274 24.4854 35.728 24 35ZM24 35L24.4854 35.728C24.1915 35.924 23.8081 35.9237 23.5142 35.7277L24 35ZM24 19.875C22.8264 19.875 21.875 20.8264 21.875 22C21.875 23.1736 22.8264 24.125 24 24.125C25.1736 24.125 26.125 23.1736 26.125 22C26.125 20.8264 25.1736 19.875 24 19.875ZM20.125 22C20.125 19.8599 21.8599 18.125 24 18.125C26.1401 18.125 27.875 19.8599 27.875 22C27.875 24.1401 26.1401 25.875 24 25.875C21.8599 25.875 20.125 24.1401 20.125 22Z"
        fill={color}
      />
    </svg>
  )
}

export default MapPinIcon
